var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-dialog-v2',{attrs:{"argument":_vm.dialog}},[_c('lookup-factory-material-component')],1)}
var staticRenderFns = []

export { render, staticRenderFns }